var lists_default = {
  "fontElementMap": "Nr6hm",
  "orderedlist": "hEGYr",
  "bulletedlist": "kOX2U",
  "listItem": "_1MPpz"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
